<template>
  <div>
    <h2>404 - Página não encontrada</h2>
  </div>
</template>
<script>
export default {
  head() {
    return {
      title: "404 - Página não encontrada",
    };
  },
};
</script>
<style scoped>
</style>